module.exports = __webpack_public_path__ + "img/btg.d46dcc12.png";